import classes from 'classnames';
import styles from './ProgressBar.module.scss';

export type Props = {
  steps: number;
  currentStep: number;
  className?: string;
};

function ProgressBar({ steps, currentStep, className }: Props) {
  const percentage = `${(currentStep / steps) * 100}%`;
  return (
    <div
      className={classes(styles.bar, className)}
      data-test="progressBar-wrapper"
    >
      <div
        className={styles.fill}
        data-test={`progressBar-${percentage}`}
        style={{ width: percentage }}
      />
    </div>
  );
}

export default ProgressBar;
